import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  CustomInput,
  Label,
  FormGroup,
  Input,
  Row } from 'reactstrap';
import Slider from 'react-rangeslider'
import NumberFormat from 'react-number-format';
import 'react-rangeslider/lib/index.css'

class DTCApply extends Component {
  state = {
    amount: 5000
  }

  handleSliderChange = (value) => {
    this.setState({
      amount: value
    })
  }

  formatter = (amount) =>
    new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(amount);

  render() {
    let { amount } = this.state;

    return (
      <div className="page-apply">
        <Container>
          <Row>

            <Col xs={12} className="mt-md-3 mb-2 mb-md-1">
              <h1 className="mb-1">Check Your Rate</h1>
              <p className="mb-1"><strong className="text-primary">Step 1 of 3</strong>&nbsp; Checking your rate takes seconds and won’t impact your credit score†</p>
            </Col>

            <Col lg={8}>
              <Row className="mt-md-3 mb-4">
                <Col xs={12}>
                  <h3 className="border-bottom pb-2 mb-1 mb-md-3">Loan Amount Requested</h3>
                </Col>
                <Col md={8} className="mb-1 mb-md-0">
                  <Slider
                    value={amount}
                    min={1000}
                    max={20000}
                    format={this.formatter}
                    tooltip={false}
                    onChange={this.handleSliderChange}
                  />
                </Col>
                <Col md={4}>
                  <NumberFormat
                    thousandSeparator={true}
                    prefix={'$'}
                    value={amount}
                    className="form-control loan-amount-input"
                  />
                </Col>
              </Row>

              <Row className="mb-4">
                <Col xs={12}>
                  <h3 className="border-bottom pb-2 mb-3">Product/Service Information</h3>
                </Col>
                <Col sm={6}>
                  <FormGroup>
                    <Input type="select" name="service-type" id="serviceType" className="required">
                      <option disabled selected>Select One...</option>
                      <option value="audiology">Audiology</option>
                      <option value="bariatrics">Bariatrics</option>
                      <option value="chiropractic">Chiropractic</option>
                      <option value="cosmeticsurgery">Cosmetic Surgery</option>
                      <option value="dental">Dental</option>
                      <option value="dermatology">Dermatology</option>
                      <option value="fertility">Fertility</option>
                      <option value="funeral">Funeral</option>
                      <option value="generalhealthcare">General Healthcare</option>
                      <option value="hairrestoration">Hair Restoration</option>
                      <option value="lasikvision">Lasik &amp; Vision</option>
                      <option value="medspa">MedSpa</option>
                      <option value="medicaldevices">Medical Devices</option>
                      <option value="veterinary">Veterinary</option>
                      <option value="petretail">Pet Retail</option>
                      <option value="bridal">Bridal</option>
                      <option value="legal">Legal</option>
                      <option value="taxdebtrelief">Tax Debt Relief</option>
                      <option value="tutoring">Tutoring</option>
                      <option value="consumergoods">Consumer Goods</option>
                      <option value="debtconsolidation">Debt Consolidation</option>
                      <option value="homeimprovement">Home Improvement</option>
                    </Input>
                    <Label for="serviceType">Product/Service Type</Label>
                  </FormGroup>
                </Col>
              </Row>

              <Row className="mb-4">
                <Col xs={12}>
                  <h3 className="border-bottom pb-2 mb-3">Personal Information</h3>
                </Col>
                <Col sm={6}>
                  <p className="mb-3">Please provide the legal name and personal identity information for the primary borrower.</p>
                </Col>
                <Col sm={6}>
                  <p className="mb-3">Enter the address of the primary borrower above. Must be a valid street address, no P.O. Boxes.</p>
                </Col>
                <Col sm={6}>
                  <FormGroup>
                    <Input type="text" name="first-name" id="firstName" className="required" />
                    <Label for="firstName">First Name</Label>
                  </FormGroup>
                </Col>
                <Col sm={6}>
                  <FormGroup>
                    <Input type="text" name="last-name" id="lastName" />
                    <Label for="lastName">Last Name</Label>
                  </FormGroup>
                </Col>
                <Col xs={12}>
                  <FormGroup className="position-relative">
                    <Input type="text" name="street-address" id="streetAddress" />
                    <Label for="streetAddress">Street Address</Label>
                    <Button size="sm" color="primary" className="btn-verify-address">Verify</Button>
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Input type="text" name="city" id="City" />
                    <Label for="City">City</Label>
                  </FormGroup>
                </Col>
                <Col xs={8} md={4}>
                  <FormGroup>
                    <Input type="select" name="state" id="State">
                      <option disabled selected>Select One...</option>
                      <option value="AL">Alabama</option>
                      <option value="AK">Alaska</option>
                      <option value="AZ">Arizona</option>
                      <option value="AR">Arkansas</option>
                      <option value="CA">California</option>
                      <option value="CO">Colorado</option>
                      <option value="CT">Connecticut</option>
                      <option value="DE">Delaware</option>
                      <option value="DC">District of Columbia</option>
                      <option value="FL">Florida</option>
                      <option value="GA">Georgia</option>
                      <option value="HI">Hawaii</option>
                      <option value="ID">Idaho</option>
                      <option value="IL">Illinois</option>
                      <option value="IN">Indiana</option>
                      <option value="IA">Iowa</option>
                      <option value="KS">Kansas</option>
                      <option value="KY">Kentucky</option>
                      <option value="LA">Louisiana</option>
                      <option value="ME">Maine</option>
                      <option value="MD">Maryland</option>
                      <option value="MA">Massachusetts</option>
                      <option value="MI">Michigan</option>
                      <option value="MN">Minnesota</option>
                      <option value="MS">Mississippi</option>
                      <option value="MO">Missouri</option>
                      <option value="MT">Montana</option>
                      <option value="NE">Nebraska</option>
                      <option value="NV">Nevada</option>
                      <option value="NH">New Hampshire</option>
                      <option value="NJ">New Jersey</option>
                      <option value="NM">New Mexico</option>
                      <option value="NY">New York</option>
                      <option value="NC">North Carolina</option>
                      <option value="ND">North Dakota</option>
                      <option value="OH">Ohio</option>
                      <option value="OK">Oklahoma</option>
                      <option value="OR">Oregon</option>
                      <option value="PA">Pennsylvania</option>
                      <option value="RI">Rhode Island</option>
                      <option value="SC">South Carolina</option>
                      <option value="SD">South Dakota</option>
                      <option value="TN">Tennessee</option>
                      <option value="TX">Texas</option>
                      <option value="UT">Utah</option>
                      <option value="VT">Vermont</option>
                      <option value="VA">Virginia</option>
                      <option value="WA">Washington</option>
                      <option value="WV">West Virginia</option>
                      <option value="WI">Wisconsin</option>
                      <option value="WY">Wyoming</option>
                    </Input>
                    <Label for="State">State</Label>
                  </FormGroup>
                </Col>
                <Col xs={4} md={2}>
                  <FormGroup>
                    <Input type="text" name="zip-code" id="zipCode" />
                    <Label for="zipCode">Zip Code</Label>
                  </FormGroup>
                </Col>
                <Col sm={6}>
                  <FormGroup>
                    <Input type="text" name="date-of-birth" id="DOB" />
                    <Label for="DOB">Date of Birth</Label>
                  </FormGroup>
                </Col>
                <Col sm={6}>
                  <FormGroup>
                    <Input type="text" name="social-security-number" id="SSN" />
                    <Label for="SSN">Social Security Number</Label>
                  </FormGroup>
                </Col>
              </Row>

              <Row className="mb-4">
                <Col xs={12}>
                  <h3 className="border-bottom pb-2 mb-3">Contact Information</h3>
                </Col>
                <Col xs={12}>
                  <p className="mb-3">Loan and application status will be sent to the following.</p>
                </Col>
                <Col sm={6}>
                  <FormGroup>
                    <Input type="email" name="email-address" id="emailAddress" />
                    <Label for="emailAddress">Email Address</Label>
                  </FormGroup>
                </Col>
                <Col sm={6}>
                  <FormGroup>
                    <Input type="text" name="mobile-phone" id="mobilePhone" />
                    <Label for="mobilePhone">Mobile Phone</Label>
                  </FormGroup>
                </Col>
              </Row>

              <Row className="mb-4">
                <Col xs={12}>
                  <h3 className="border-bottom pb-2 mb-3">Financials &amp; Employment</h3>
                </Col>
                <Col xs={12}>
                  <p className="mb-3">Your total verifiable gross income might include your salary, retirement income or other sources of income. You don't have to include alimony, child support, or separate maintenance income unless you want it considered as a basis for repayment.</p>
                </Col>
                <Col sm={6}>
                  <FormGroup>
                    <Input type="text" name="monthly-income" id="monthlyIncome" />
                    <Label for="monthlyIncome">Gross Monthly Income</Label>
                  </FormGroup>
                </Col>
                <Col sm={6}>
                  <FormGroup>
                    <Input type="select" name="rent-own" id="rentOwn">
                      <option disabled selected>Select One...</option>
                      <option value="own">Own</option>
                      <option value="rent">Rent</option>
                      <option value="parents">Live with parents</option>
                      <option value="other">Other</option>
                    </Input>
                    <Label for="rentOwn">Rent/Own</Label>
                  </FormGroup>
                </Col>
                <Col sm={6}>
                  <FormGroup>
                    <Input type="text" name="monthly-rent" id="monthlyRent" />
                    <Label for="monthlyRent">Monthly Rent/Mortgage</Label>
                  </FormGroup>
                </Col>
                <Col sm={6}>
                  <FormGroup>
                    <Input type="select" name="employment" id="Employment">
                      <option disabled selected>Select One...</option>
                      <option value="employed">Employed</option>
                      <option value="self-employed">Self-Employed</option>
                      <option value="unemployed">Unemployed</option>
                      <option value="student">Student</option>
                      <option value="retired">Retired</option>
                      <option value="military">Military</option>
                    </Input>
                    <Label for="Employment">Employment Status</Label>
                  </FormGroup>
                </Col>
                <Col sm={6}>
                  <FormGroup>
                    <Input type="text" name="employer-name" id="employerName" />
                    <Label for="employerName">Employer Name</Label>
                  </FormGroup>
                </Col>
                <Col sm={6}>
                  <FormGroup>
                    <Input type="text" name="employer-phone" id="employerPhone" />
                    <Label for="employerPhone">Employer Phone</Label>
                  </FormGroup>
                </Col>
                <Col sm={6}>
                  <FormGroup>
                    <Input type="select" name="years-employed" id="yearsEmployed">
                      <option disabled selected>Select One...</option>
                      <option value="less-than-6-months">Less than 6 months</option>
                      <option value="6-mo-to-1-yr">6 Months – 1 Year</option>
                      <option value="1-2-years">1–2 Years</option>
                      <option value="2-3-years">2-3 Years</option>
                      <option value="3-plus-years">3+ Years</option>
                    </Input>
                    <Label for="yearsEmployed">Years with Current Employer</Label>
                  </FormGroup>
                </Col>
              </Row>

              <Row className="mb-4">
                <Col xs={12}>
                  <h3 className="border-bottom pb-2 mb-3">Your Signature</h3>
                </Col>
                <Col xs={12}>
                  <Row>
                    <Col>
                      <h5>Is the applicant above the person receiving the product/services?</h5>
                    </Col>
                    <Col sm="auto">
                      <FormGroup>
                        <CustomInput type="radio" id="verifyApplicant" name="verifyApplicant" label="Yes" inline />
                        <CustomInput type="radio" id="verifyApplicant2" name="verifyApplicant" label="No" inline />
                      </FormGroup>
                    </Col>
                    <Col xs={12} className="mb-1">
                      <h5 className="mb-1">By checking the box below I agree to the following:</h5>
                      <FormGroup>
                        <CustomInput type="checkbox" id="Checkbox1" label="Electronic Consent" />
                        <CustomInput type="checkbox" id="Checkbox2" label="I consent to the following terms, conditions, acknowledgements and disclosures" />
                        <CustomInput type="checkbox" id="Checkbox3" label="I consent to receive the following calls and text messages" />
                      </FormGroup>
                    </Col>
                    <Col sm={9}>
                      <FormGroup>
                        <Input type="text" name="signature" id="Signature" />
                        <Label for="Signature">Applicant Signature (Type full name)</Label>
                      </FormGroup>
                    </Col>
                    <Col sm={3} className="mb-2">
                      <FormGroup>
                        <Input type="text" name="signature-date" id="signatureDate" readOnly />
                        <Label for="signatureDate">Date</Label>
                      </FormGroup>
                    </Col>
                    <Col xs={12}>
                      <h5 className="mb-1">Important information about procedures for opening a new account</h5>
                      <FormGroup>
                        <Input type="textarea" name="important-info" id="importantInfo" className="disclaimer" rows="4" value="To help the government fight the funding of terrorism and money laundering activities, federal law requires all financial institutions to obtain, verify, and record information that identifies each person who opens an account or applies for a loan from Cross River Bank (“we”). What this means for you: When you open an account or apply for a loan, we will ask for your name, address, date of birth and other information that will allow us to identify you. We may also ask to see your driver’s license or other identifying documents. If you fail to provide the required information, we may be unable to open an account or grant you a loan." readOnly />
                      </FormGroup>
                    </Col>
                    <Col xs={12}>
                      <div className="border-top pt-3 mt-1">
                        <Button tag={Link} to="/dtc/merchant" id="ContinueButton" size="lg" color="primary">Submit Application <img src="/icons/arrow-right-lg.svg" alt="" /></Button>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>

            <Col lg={4}>
              <div className="apply-sidebar sticky-top pt-3 mb-2 ml-lg-3">
                <Card className="text-center border-light">
                  <CardBody>
                    <Row>
                      <Col xs={12} className="mt-1 mb-3">
                        <img src="/icons/apply-step-1.svg" alt="" className="mb-1" />
                        <h5>Complete our fast and easy loan application</h5>
                      </Col>
                      <Col xs={12} className="mb-3">
                        <img src="/icons/apply-step-2.svg" alt="" className="mb-1" />
                        <h5>Select a merchant or locate a business by name</h5>
                      </Col>
                      <Col xs={12}>
                        <img src="/icons/apply-step-3.svg" alt="" className="mb-1" />
                        <h5>Get a loan decision in seconds!</h5>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
                <Row>
                  <Col>
                    <img src="/icons/secure.svg" alt="SSL Secure" className="float-left mr-1" />
                    <p style={{lineHeight: 1.2}}><small><strong>128-bit SSL</strong> protection and strict encryption</small></p>
                  </Col>
                  <Col xs="auto">
                    <img src="/icons/digicert.png" width="56" alt="Digicert Secure" />
                  </Col>
                </Row>
              </div>
            </Col>

          </Row>
          <Row>
            <Col sm={12} className="mt-3 mb-2">
              <small className="text-muted">All loans are made by Cross River Bank, a New Jersey State Chartered Bank. Member FDIC. Loan amounts range from $1,000 to $20,000. No loans are offered in Connecticut, New Hampshire, West Virginia, Vermont, Puerto Rico or any other unincorporated US territory. The APR’s range from 19.48% APR to 29.99% APR. An origination fee of 8% may be included in the principal loan amount that results in an APR up to 29.99%.<br /><br />
              *Your loan has a 6-month no interest on principal promotion included. This promotion can save you money if you pay off the principal amount of the loan in full within the first 6 months. During the 6-month promotional period you will be responsible for making all of your monthly payments and your loan will accrue interest on a monthly basis. If you pay off your loan within the promotional period, the monthly payments that you have made during this period, which includes accrued interest, will be deducted from the principal amount of the loan. The principal amount may include an 8% origination fee.<br /><br />
              † To check the rates you qualify for, LendingUSA does a soft credit pull that will not impact your credit score. However, if you choose to continue your application, your full credit report will be requested from one or more consumer reporting agencies, which is considered a hard credit pull.</small>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}

export default DTCApply;
